<script>
    export default {
        name: 'AuthVerifySelectMethod',

        props: {
            hasEmail: {
                type: Boolean,
            },
            hasMobile: {
                type: Boolean,
            },
            email: {
                type: String,
            },
            mobile: {
                type: String,
            },
        },
        data() {
            return {
                disabledButton: true,
            }
        },
    }
</script>
<template>
    <div>
        <div class="row">
            <div class="col-md-1 d-none d-md-block"></div>
            <div class="group-of-options col-12 col-md-11 mt-3">
                <div class="d-flex align-items-center checkbox-wrapper mb-3">
                    <div :class="hasEmail ? 'black-checkbox checkbox-option-item' : 'checkbox-option-item black-checkbox grey-no-2fa-info'">
                        <input
                            id="tokenEmail"
                            required
                            type="radio"
                            name="token_type"
                            value="email"
                            class="form-check-input me-2"
                            :disabled="!hasEmail"
                            @input="disabledButton = false"
                        >
                        <label class="box-checking box-full-width" for="tokenEmail" id="tokenEmailLabel"></label>
                    </div>
                    <label for="tokenEmail" id="tokenEmailLabel">Email ({{ email }})</label>
                </div>
                <div class="d-flex align-items-center checkbox-wrapper mb-3">
                    <div :class="hasMobile ? 'black-checkbox checkbox-option-item' : 'checkbox-option-item black-checkbox grey-no-2fa-info'">
                        <input
                            id="tokenText"
                            required type="radio"
                            name="token_type"
                            value="text"
                            class="form-check-input me-2"
                            :disabled="!hasMobile"
                            @input="disabledButton = false"
                        >
                        <label class="box-checking box-full-width" for="tokenText"></label>
                    </div>
                    <label for="tokenText">Text Message ({{ mobile }})</label>
                </div>
                <div class="d-flex align-items-center checkbox-wrapper mb-3">
                    <div :class="hasMobile ? 'black-checkbox checkbox-option-item' : 'checkbox-option-item black-checkbox grey-no-2fa-info'">
                        <input
                            id="tokenPhone"
                            required
                            type="radio"
                            name="token_type"
                            value="phone"
                            class="form-check-input me-2"
                            :disabled="!hasMobile"
                            @input="disabledButton = false"
                        >
                        <label class="box-checking box-full-width" for="tokenPhone"></label>
                    </div>
                    <label for="tokenPhone">Phone Call ({{ mobile }})</label>
                </div>
            </div>
        </div>
        <div class="pt-3 pt-md-4 text-right">
            <button type="submit" class="submit btn btn-primary" :disabled="disabledButton">Continue</button>
        </div>
    </div>
</template>
<style scoped>
    .grey-no-2fa-info {
        opacity: 0.4;
    }
    .grey-no-2fa-info + label {
        opacity: 0.4;
        cursor: not-allowed;
    }
</style>
